// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1kyMH","left":"InfoRow_left__qD2u5"};